<template>
  <div class="pc-newsList">
    <BreadCrumb :data="breadcrumb" :title="'竞赛作品管理'" />
    <NewCompetitionWorkTable />
  </div>
</template>


<script>
import BreadCrumb from "../../componentSet/BreadCrumb";
import NewCompetitionWorkTable from "./components/NewCompetitionWorkTable";
import {

} from "../../../apis/competition.api";
export default {
  components: {
    BreadCrumb,
    NewCompetitionWorkTable
  },
  data() {
    return {
    };
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "竞赛作品列表", link: "/admin/newCompetitionWork" },
      ];
    },
  },
  mounted() {
  },
  methods: {}
};
</script>




// WEBPACK FOOTER //
// src/components/admin/competition/NewCompetitionWorkList.vue